import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';
import { getTheme, ifProp, size } from 'mol-ui';

export const CalendarContainer = styled.div`

`;

export const Col = styled(Col_)`

`;

export const Container = styled.div`
    height: 100%;
    padding: 20px;
`;

export const DoctorMessage = styled.div`
    color: ${ getTheme('textColor') };
    font-size: 14px;
    ${ size.xs(`
        display: none;
    `) }
`;

export const FilterCol = styled(Col_)`
    margin-top: 10px;
`;

export const FilterContainer = styled.div`
    background-color: #FFF;
    border: 1px solid ${ getTheme('primaryColor') };
    margin-bottom: 10px;
`;

export const Filters = styled.div`
    ${ ifProp('active', '', `
        ${ size.xs(`
            display: none;
        `) }
    `) }
`;

export const OnlyXS = styled.div`
    display: none;
    ${ size.xs(`
        display: flex;
    `) }
`;

export const Row = styled(Row_)`

`;
